



























import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import InViewport from '~/mixins/InViewport';

@Component
export default class AboutUsRotatingGlobe extends Mixins(InViewport) {
  @Prop(String) backgroundId!: string;

  vid!: HTMLVideoElement;
  canvas!: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D | null = null;
  vidWidth!: number;
  vidHeight!: number;

  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  handleGlobeLoaded() {
    this.vid = this.$refs.globeVid as HTMLVideoElement;
    this.canvas = this.$refs.globeCanvas as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.vidWidth = this.vid.videoWidth;
    this.vidHeight = this.vid.videoHeight;

    this.canvas.width = this.vid.offsetWidth;
    this.canvas.height = this.vid.offsetHeight;
    window.addEventListener('resize', this.handleWindowResize);

    this.drawingLoop();

    setTimeout(() => {
      this.setVideoBgColor(this.vid);
    }, 150);
  }

  drawingLoop() {
    window.requestAnimationFrame(this.drawingLoop);
    if (
      this.ctx &&
      this.vid &&
      this.canvas &&
      this.vidWidth &&
      this.vidHeight
    ) {
      this.ctx.drawImage(
        this.vid,
        0,
        0,
        this.vidWidth,
        this.vidHeight, // source rectangle
        0,
        0,
        this.canvas.width,
        this.canvas.height,
      ); // destination rectangle);
    }
  }

  setVideoBgColor(vid: HTMLVideoElement) {
    // draw first four pixel of video to a canvas
    // then get pixel color from that canvas
    const canvas = document.createElement('canvas');
    canvas.width = 8;
    canvas.height = 8;
    const backgroundElement = document.getElementById(this.backgroundId);
    const ctx = canvas.getContext('2d');

    if (ctx && backgroundElement) {
      ctx.drawImage(vid, 0, 0, 8, 8);

      const p = ctx.getImageData(0, 0, 8, 8).data;
      //dont take the first but fourth pixel [r g b]
      backgroundElement.style.backgroundColor =
        'rgb(' + p[60] + ',' + p[61] + ',' + p[62] + ')';
    }
  }

  handleWindowResize() {
    this.vidWidth = this.vid.videoWidth;
    this.vidHeight = this.vid.videoHeight;

    this.canvas.width = this.vid.offsetWidth;
    this.canvas.height = this.vid.offsetHeight;

    if (this.ctx) {
      //redraw canvas after resize
      this.ctx.drawImage(
        this.vid,
        0,
        0,
        this.vidWidth,
        this.vidHeight, // source rectangle
        0,
        0,
        this.canvas.width,
        this.canvas.height,
      ); // destination rectangle);
    }
  }

  @Watch('inViewport.now', { immediate: true })
  handleInViewportChange(val: boolean, oldVal: boolean) {
    if (val) {
    } else if (oldVal && !val) {
    }
  }
}
